module.exports = __webpack_public_path__ + "97b932445b2daed7b3f5cbc7ffaaebf7.png";